import { memo, ReactNode } from 'react'

import { TabContext } from './TabContext'

interface IProps {
  children: ReactNode
  tabId: string
  className?: string
}

export const TabContent = memo(function TabContent({ className, tabId, ...props }: IProps) {
  return (
    <TabContext.Consumer>
      {({ currentTab }) => (currentTab === tabId ? <div className={className} {...props} /> : null)}
    </TabContext.Consumer>
  )
})
